import {
  ClientConfigurationParams,
  getAWAdvisorConfigurationApi,
  getClientConfigurationListApi,
} from '../../api/AWBffServer';
import { configQueryKeys } from './queryKeys';

/**
 * TanStack Query object for ui configuration.
 * Use with useSuspenseQuery or useQuery in components.
 */
export const uiConfigurationQuery = (params: ClientConfigurationParams) => ({
  queryKey: configQueryKeys.advisor(params),
  queryFn: async () => {
    const response = await getAWAdvisorConfigurationApi(params);
    return response.data;
  },
});

export const clientConfigurationsQuery = {
  queryKey: configQueryKeys.packages(),
  queryFn: async () => {
    const response = await getClientConfigurationListApi();
    return response.data;
  },
};
